import { gql } from '../../../__generated__';

export const GET_CURRENT_USER = gql(`
  query GetLoggedInUserWeb {
    getLoggedInUserWeb {
      firstName
      lastName
      phoneNo
      email
      avatar
      id
      countryCode
    }
  }
`);
